// CommonJS packages compiled from ESM (Babel, webpack) keep their default export on
// module.exports.default. ui/package.json is "type": "module", so Vite 8 and Node hand a default
// import the whole module.exports object instead, and the export has to be unwrapped.
export function cjsDefault<T>(imported: T | { default: T }): T {
  return imported !== null && typeof imported === 'object' && 'default' in imported
    ? (imported as { default: T }).default
    : (imported as T);
}
